import { useEffect, useState } from "react";
import { Headset, X } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { SupportChat } from "@/components/SupportChat";
import { ContactForm } from "@/components/ContactForm";

export const SupportWidget = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("open-support", h);
    return () => window.removeEventListener("open-support", h);
  }, []);
  if (!user) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50">
      {open && (
        <div className="fade-up mb-3 w-[calc(100vw-2.5rem)] max-w-sm rounded-2xl border border-[#212638] bg-[#151824]/95 p-4 shadow-2xl backdrop-blur-xl" data-testid="support-panel">
          <div className="mb-3 flex items-center justify-between">
            <div>
              <p className="font-display font-semibold tracking-tight">Support</p>
              <p className="text-[11px] text-[#64748B]">AI assistant · replies instantly</p>
            </div>
            <button onClick={() => setOpen(false)} data-testid="support-close-button" className="rounded-lg p-1 text-[#94A3B8] transition-colors hover:bg-[#1C2030] hover:text-white"><X size={16} /></button>
          </div>
          <Tabs defaultValue="chat">
            <TabsList className="mb-3 grid h-auto w-full grid-cols-2 rounded-xl border border-[#212638] bg-[#0F111A] p-1">
              <TabsTrigger value="chat" data-testid="support-tab-chat" className="rounded-lg py-1.5 text-xs font-semibold data-[state=active]:bg-[#F7931A] data-[state=active]:text-[#08090E]">Chat</TabsTrigger>
              <TabsTrigger value="contact" data-testid="support-tab-contact" className="rounded-lg py-1.5 text-xs font-semibold data-[state=active]:bg-[#F7931A] data-[state=active]:text-[#08090E]">Contact us</TabsTrigger>
            </TabsList>
            <TabsContent value="chat"><SupportChat /></TabsContent>
            <TabsContent value="contact"><ContactForm /></TabsContent>
          </Tabs>
        </div>
      )}
      <button onClick={() => setOpen((o) => !o)} data-testid="support-open-button"
        className="ml-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#F7931A] text-[#08090E] shadow-lg shadow-[#F7931A]/20 transition-transform hover:scale-105">
        {open ? <X size={22} /> : <Headset size={22} />}
      </button>
    </div>
  );
};
